type ErrosPlanos = Record<string, string[]>;
type ErrosAninhados = Record<string, any>;

export function transformarErros(errosPlanos: ErrosPlanos): ErrosAninhados {
  const resultado: ErrosAninhados = {};

  for (const key in errosPlanos) {
    const keys = key.split('.');
    let current: any = resultado;

    keys.forEach((k, i) => {
      if (!current[k]) {
        current[k] = i === keys.length - 1 ? errosPlanos[key] : {};
      }
      current = current[k];
    });
  }

  return resultado;
}
